import { render, staticRenderFns } from "./item-editor-custom.vue?vue&type=template&id=3d532f0a"
import script from "./item-editor-custom.vue?vue&type=script&lang=ts"
export * from "./item-editor-custom.vue?vue&type=script&lang=ts"
import style0 from "./item-editor-custom.vue?vue&type=style&index=0&id=3d532f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports